import { render } from "./Hero.vue?vue&type=template&id=7d7d46ce&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=7d7d46ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d7d46ce"

export default script